
		<div class="d-inline-block" ngbDropdown #myDropdown="ngbDropdown" [autoClose]="'outside'">
			<input
			    ngbDropdownToggle
			    class="form-control"
			    [(ngModel)]="dt"
			    (input)="onInput($event)"
			    (click)="onInputClick($event);"
			    [disabled]="disabled"
			   />
			
			<span class="fa fa-calendar-alt" aria-hidden="true" (click)="onInputClick($event);"></span>
			
			<div ngbDropdownMenu>
				<ngb-datepicker
					#myDatepicker
					[firstDayOfWeek]="1"
					[(ngModel)]="modelD"
					(click)="onDatepickerClick($event)"
					[disabled]="disabled"
					[minDate]="minDate"
					[maxDate]="maxDate"
				></ngb-datepicker>
				
				<div style="clear: both;"></div>

				<div class="card" *ngIf="enabledTime">
					<div class="card-block">
						<div class="row">
							<div class="col">&nbsp;</div>
							<div class="col-md-auto">
								<a href="#" (click)="$event.preventDefault(); showTimepicker();">&#9200;</a>
							</div>
							<div class="col">&nbsp;</div>
						</div>
						<div class="row" *ngIf="visibleTimepicker">
							<div class="col">&nbsp;</div>
							<div class="col-md-auto">
								<ngb-timepicker [(ngModel)]="modelT" [minuteStep]="30" [size]="'small'"></ngb-timepicker>
							</div>
							<div class="col">&nbsp;</div>
						</div>
					</div>
				</div>
			</div>
		</div>